// Flat inline vector icons. The app uses no emojis — platform emoji rendering
// is inconsistent (and several unicode symbols like U+26A0 get forced emoji
// presentation on mobile) — so pictographs are drawn as simple flat vectors.

// Little green wine bottle with a label — the producer glyph everywhere
// (multicolor inline SVG like HeliIcon; ignores currentColor).
export function BottleIcon({ size = 17, style }) {
  // the box hugs the artwork (9.9 of 24 units wide): a square box pads the
  // narrow bottle with dead space and makes flex gaps look wider than they are
  return (
    <svg viewBox="7.05 0 9.9 24" width={(size * 9.9) / 24} height={size} aria-hidden="true" style={style}>
      <path d="M10.6 1.6h2.8v4.6c0 .9.5 1.4 1.3 2 .9.7 1.4 1.6 1.4 2.9v9.2c0 .7-.5 1.2-1.2 1.2H9.1c-.7 0-1.2-.5-1.2-1.2v-9.2c0-1.3.5-2.2 1.4-2.9.8-.6 1.3-1.1 1.3-2V1.6z" fill="#55803e" stroke="#31303e" strokeWidth="1.3" strokeLinejoin="round" />
      <rect x="10.6" y="1.9" width="2.8" height="2.6" fill="#3c5b2c" />
      <rect x="8.9" y="12.6" width="6.2" height="5.4" rx="0.8" fill="#f2ead6" stroke="#31303e" strokeWidth="1" />
      <path d="M9.2 10.9q-.3 3.4.1 8" fill="none" stroke="#7ba55e" strokeWidth="0.9" strokeLinecap="round" opacity="0.9" />
    </svg>
  );
}


// Flat eye — map-visibility toggle in the sidebar section titles.
export function EyeIcon({ size = 14, style }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={style}>
      <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

// Flat helicopter — the fly-through launcher marker; rotor caught at 45°
// so the still image reads as a helicopter, not a crosshair.
export function HeliIcon({ size = 16, style }) {
  return (
    <svg viewBox="0 0 34 34" width={size} height={size} aria-hidden="true" style={style}>
      <rect x="15.4" y="17" width="3.2" height="11" rx="1.4" fill="#374151" />
      <rect x="12.2" y="26.6" width="9.6" height="1.9" rx="0.95" fill="#374151" />
      <ellipse cx="17" cy="13.5" rx="5.2" ry="7.2" fill="#4A235A" />
      <ellipse cx="17" cy="10.6" rx="3.1" ry="3.4" fill="#c4b5fd" />
      <g stroke="#1c1c1c" strokeWidth="1.6" strokeLinecap="round" transform="rotate(45 17 13.5)">
        <line x1="3" y1="13.5" x2="31" y2="13.5" />
        <line x1="17" y1="0.5" x2="17" y2="27.5" />
      </g>
      <circle cx="17" cy="13.5" r="1.7" fill="#1c1c1c" />
    </svg>
  );
}

// Flat five-point star — marks Mike's favorite German producers.
export function StarIcon({ size = 13, style }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true" style={style}>
      <path d="M12 2.6 14.9 8.5 21.4 9.4 16.7 14 17.8 20.5 12 17.4 6.2 20.5 7.3 14 2.6 9.4 9.1 8.5z" />
    </svg>
  );
}

// Flat funnel — map filter toggle beside the sidebar eye toggles.
export function FilterIcon({ size = 14, style }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={style}>
      <path d="M3 4.5h18l-7 8.2v6.3l-4 2v-8.3L3 4.5z" />
    </svg>
  );
}

// The eye struck through — the toggled-off state.
export function EyeOffIcon({ size = 14, style }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={style}>
      <path d="M2.6 8.2A19.2 19.2 0 0 0 1 12s4 7 11 7c1.5 0 2.9-.3 4.1-.8M8.6 5.6A10.9 10.9 0 0 1 12 5c7 0 11 7 11 7a19 19 0 0 1-2.2 3.1" />
      <path d="M9.9 9.9a3 3 0 1 0 4.2 4.2" />
      <line x1="3.5" y1="3.5" x2="20.5" y2="20.5" />
    </svg>
  );
}

export function ExitIcon({ size = 14, style }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={style}>
      <path d="M15 21h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-4" />
      <polyline points="8 17 3 12 8 7" />
      <line x1="3" y1="12" x2="15" y2="12" />
    </svg>
  );
}

export function MapIcon({ size = 14, style }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={style}>
      <path d="M9 4 3 6v14l6-2 6 2 6-2V4l-6 2-6-2z" />
      <line x1="9" y1="4" x2="9" y2="18" />
      <line x1="15" y1="6" x2="15" y2="20" />
    </svg>
  );
}

export function WarnIcon({ size = 14, style }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true" style={style}>
      <path fillRule="evenodd" d="M12 2.5 23 21.5H1L12 2.5zm-1.1 7.2h2.2v5.8h-2.2V9.7zm0 7.2h2.2v2.2h-2.2v-2.2z" />
    </svg>
  );
}

export function CarIcon({ size = 20, style }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={style}>
      <path d="M5 11 6.6 6.8A2 2 0 0 1 8.5 5.5h7a2 2 0 0 1 1.9 1.3L19 11" />
      <path d="M4 11h16a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1" />
      <path d="M3 12v4a1 1 0 0 0 1 1h1" />
      <circle cx="7.5" cy="16.5" r="1.7" />
      <circle cx="16.5" cy="16.5" r="1.7" />
      <path d="M9.2 17h5.6" />
    </svg>
  );
}

export function ExternalLinkIcon({ size = 11, style }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ verticalAlign: '-0.5px', marginRight: '0.3em', ...style }}>
      <path d="M6 18 18 6" />
      <path d="M9 6h9v9" />
    </svg>
  );
}

// The 3D modal's compass rose as a React component (same geometry as the
// DOM rose MeshView builds imperatively). innerRef lets callers spin it.
export function CompassRose({ size = 24, innerRef, className, style }) {
  return (
    <svg ref={innerRef} viewBox="0 0 44 44" width={size} height={size} className={className} style={style} aria-hidden="true">
      <circle cx="22" cy="22" r="20.5" fill="rgba(250,249,246,0.92)" stroke="rgba(0,0,0,0.15)" />
      <path d="M22 4.5 L19.4 11 L24.6 11 Z" fill="#dc2626" />
      <text x="22" y="18.5" textAnchor="middle" fontSize="9" fontWeight="700" fill="#dc2626">N</text>
      <text x="34" y="25.5" textAnchor="middle" fontSize="8" fontWeight="600" fill="#a8a29e">O</text>
      <text x="22" y="38" textAnchor="middle" fontSize="8" fontWeight="600" fill="#a8a29e">S</text>
      <text x="10" y="25.5" textAnchor="middle" fontSize="8" fontWeight="600" fill="#a8a29e">W</text>
    </svg>
  );
}

// Flat compass: ring + needle rotated to point at `angle` degrees (0 = N, clockwise).
export function CompassIcon({ angle = 0, size = 16, style }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true" style={style}>
      <circle cx="12" cy="12" r="10.2" fill="none" stroke="currentColor" strokeWidth="1.5" />
      <path d="M12 4.2 14.6 13.4 12 11.6 9.4 13.4z" fill="currentColor" transform={`rotate(${angle} 12 12)`} />
    </svg>
  );
}

// Flat house (village marker) — solid silhouette with a door opening.
export function HouseIcon({ size = 16, style }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true" style={style}>
      <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
    </svg>
  );
}

// Vine glyph (public/vine.png alpha mask) painted via CSS mask so it takes
// currentColor — gold wherever the old notable star was gold.
export function VineIcon({ size = '1em', style }) {
  return <span className="vine-icon" style={{ width: size, height: size, ...style }} aria-hidden="true" />;
}

// Three flat raindrops.
export function RainIcon({ size = 16, style }) {
  const drop = (cx, ty) =>
    `M${cx} ${ty} Q${cx + 2.9} ${ty + 4.4} ${cx + 2.9} ${ty + 6.3} A2.9 2.9 0 1 1 ${cx - 2.9} ${ty + 6.3} Q${cx - 2.9} ${ty + 4.4} ${cx} ${ty}Z`;
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true" style={style}>
      <path d={drop(6.7, 2.6)} />
      <path d={drop(17.3, 2.6)} />
      <path d={drop(12, 12)} />
    </svg>
  );
}

// Flat sun: disc + eight rays.
export function SunIcon({ size = 16, style }) {
  const rays = [];
  for (let i = 0; i < 8; i++) {
    const a = (i * Math.PI) / 4;
    rays.push(
      <line
        key={i}
        x1={(12 + 7.3 * Math.sin(a)).toFixed(2)} y1={(12 - 7.3 * Math.cos(a)).toFixed(2)}
        x2={(12 + 10.4 * Math.sin(a)).toFixed(2)} y2={(12 - 10.4 * Math.cos(a)).toFixed(2)}
      />
    );
  }
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true" style={style}>
      <circle cx="12" cy="12" r="4.7" fill="currentColor" />
      <g stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">{rays}</g>
    </svg>
  );
}

// Flat thermometer: tube outline in currentColor, mercury red (overridable
// for the empty/placeholder state).
export function ThermometerIcon({ size = 16, mercury = '#dc2626', style }) {
  return (
    // viewBox hugs the glyph (it spans ~11 of 24 units horizontally): a full
    // 0 0 24 24 box leaves ~6 units of invisible padding per side, which
    // reads as a wider gap to the value than the other fact icons.
    <svg viewBox="6.4 1.8 11.2 21" width={size * 11.2 / 21} height={size} fill="none" aria-hidden="true" style={style}>
      <path
        d="M12 2.8a2.2 2.2 0 0 1 2.2 2.2v8.4a4.6 4.6 0 1 1-4.4 0V5A2.2 2.2 0 0 1 12 2.8z"
        stroke="currentColor" strokeWidth="1.5"
      />
      <circle cx="12" cy="17.4" r="2.5" fill={mercury} />
      <rect x="11.15" y="9.2" width="1.7" height="8.2" rx="0.85" fill={mercury} />
    </svg>
  );
}

// Flat line graph — grey axes in currentColor, data line in the brand's
// dark purple (#4A235A). Monthly-weather toggle logo.
export function ChartLineIcon({ size = 16, style }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" aria-hidden="true" style={style}>
      <path d="M3.5 3.5v16.5h17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <polyline points="6.5,15.5 10.5,9.5 14,12.5 20,5.5" stroke="#4A235A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

// Flat outline globe — circle, one meridian ellipse, equator and two
// curved parallels, all currentColor. Google Earth link icon.
export function EarthIcon({ size = 16, style }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" aria-hidden="true" style={style}>
      <circle cx="12" cy="12" r="9.3" />
      <ellipse cx="12" cy="12" rx="4.3" ry="9.3" />
      <path d="M2.7 12h18.6" />
      <path d="M4.5 7.2c2.4 1.1 12.6 1.1 15 0" />
      <path d="M4.5 16.8c2.4-1.1 12.6-1.1 15 0" />
    </svg>
  );
}

// Flat faceted rock — soil-notes bullet. Solid silhouette in currentColor
// with two translucent facets for the cut-stone read.
export function RockIcon({ size = 15, style }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true" style={style}>
      <path d="M7.2 4.6 15.9 3.4 21.3 9.8 19.6 19.2 5.6 19.9 2.6 12.3z" fill="currentColor" />
      <path d="M15.9 3.4 13.4 10.9 21.3 9.8z" fill="rgba(255,255,255,0.28)" />
      <path d="M13.4 10.9 5.6 19.9 19.6 19.2z" fill="rgba(255,255,255,0.14)" />
    </svg>
  );
}

// Flat right-triangle ramp rising to the right — slope pictograph.
// Expand-to-fullscreen: two diagonal corner arrows.
export function ExpandIcon({ size = 13, style }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={style}>
      <path d="M14 4h6v6" />
      <path d="M20 4l-7 7" />
      <path d="M10 20H4v-6" />
      <path d="M4 20l7-7" />
    </svg>
  );
}

export function SlopeIcon({ size = 16, style }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true" style={style}>
      <path d="M2.5 19.5 21.5 6.8V19.5H2.5z" />
    </svg>
  );
}

// Flat twin-peak mountain, secondary peak lighter for depth.
export function MountainIcon({ size = 16, style }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true" style={style}>
      <path d="M8.3 9.8 13.2 19.5H2.5L8.3 9.8z" opacity="0.45" />
      <path d="M14.6 5 21.8 19.5H7.9L14.6 5z" />
    </svg>
  );
}

export function CheckboxIcon({ checked, size = 13, style }) {
  return (
    <svg viewBox="0 0 16 16" width={size} height={size} aria-hidden="true" style={{ verticalAlign: '-1.5px', ...style }}>
      <rect x="1.25" y="1.25" width="13.5" height="13.5" rx="3" fill={checked ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="1.5" />
      {checked && <path d="M4.6 8.3 7 10.6l4.4-5" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />}
    </svg>
  );
}

